import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
import { ApiHttp } from 'app/providers';

@Injectable()
export class PromoSponsorService {
    constructor(
        private apiHttp: ApiHttp) {
    }

    public getSponsors(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminPromoSponsor/GetSponsors', data, messageService);
    }

    public getSponsor(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminPromoSponsor/GetSponsor', data, messageService);
    }

    public addOrUpdateSponsor(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminPromoSponsor/AddOrUpdateSponsor', data, messageService);
    }

    public setSponsorActive(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminPromoSponsor/SetSponsorActive', data, messageService);
    }
}
